const styles = () => ({
  associate: {
    display: 'inline-flex',
    fontSize: 16,
    fontWeight: 400,
    width: 20,
    height: 20,
    marginLeft: 3,
    marginRight: 3,
  },
});

export default styles;
